import { CELLECALENDARIO, PAGINEDETAIL } from 'utils/endpoint'
import { api } from 'utils'
import MetaSeo from 'components/atomic/MetaSeo'
import CalendarioAvventoTemplate from 'react-components/templates/CalendarioAvventoTemplate/CalendarioAvventoTemplate'

api.defaults.xsrfCookieName = 'csrftoken'
api.defaults.xsrfHeaderName = 'X-CSRFTOKEN'

const CalendarioAvvento = ({ pagina, celle }) => {
  return (
    <>
      <MetaSeo seo={pagina.seo} />
      <CalendarioAvventoTemplate celleInitial={celle} />
    </>
  )
}

CalendarioAvvento.getInitialProps = async ({ res, req }) => {
  const headers = req?.headers?.cookie ? { cookie: req.headers.cookie } : undefined
  try {
    const pageResponse = await api.get(PAGINEDETAIL, {
      params: {
        chiave: 'calendario-avvento',
      },
    })
    const pagina = await pageResponse.data
    const toolbarProps = { toolbarPage: pagina }

    const response = await api.get(CELLECALENDARIO, {
      headers,
    })
    const celle = response.data

    return { pagina, celle, ...toolbarProps }
  } catch (error) {
    if (res) {
      res.statusCode = 404
    }
    return { statusCode: 404 }
  }
}

export default CalendarioAvvento
